/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartialProfitabilityData } from './PartialProfitabilityData';
import {
    PartialProfitabilityDataFromJSON,
    PartialProfitabilityDataFromJSONTyped,
    PartialProfitabilityDataToJSON,
    PartialProfitabilityDataToJSONTyped,
} from './PartialProfitabilityData';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';
import type { NullableMoneyOutput } from './NullableMoneyOutput';
import {
    NullableMoneyOutputFromJSON,
    NullableMoneyOutputFromJSONTyped,
    NullableMoneyOutputToJSON,
    NullableMoneyOutputToJSONTyped,
} from './NullableMoneyOutput';
import type { MediaSourceQuality } from './MediaSourceQuality';
import {
    MediaSourceQualityFromJSON,
    MediaSourceQualityFromJSONTyped,
    MediaSourceQualityToJSON,
    MediaSourceQualityToJSONTyped,
} from './MediaSourceQuality';

/**
 * 
 * @export
 * @interface MarketingTrendRowData
 */
export interface MarketingTrendRowData {
    /**
     * 
     * @type {string}
     * @memberof MarketingTrendRowData
     */
    date?: string;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof MarketingTrendRowData
     */
    spend?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof MarketingTrendRowData
     */
    turnover?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof MarketingTrendRowData
     */
    turnoverCompleted?: MoneyOutput;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof MarketingTrendRowData
     */
    goodsMargin?: NullableMoneyOutput | null;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof MarketingTrendRowData
     */
    goodsMarginCompleted?: NullableMoneyOutput | null;
    /**
     * Unknown purchase-cost count for completed plus received orders.
     * @type {number}
     * @memberof MarketingTrendRowData
     */
    purchaseCostUnknownGross?: number;
    /**
     * Unknown purchase-cost count for completed orders.
     * @type {number}
     * @memberof MarketingTrendRowData
     */
    purchaseCostUnknownCompleted?: number;
    /**
     * Estimated purchase-cost count for completed plus received orders.
     * @type {number}
     * @memberof MarketingTrendRowData
     */
    purchaseCostEstimatedGross?: number;
    /**
     * Estimated purchase-cost count for completed orders.
     * @type {number}
     * @memberof MarketingTrendRowData
     */
    purchaseCostEstimatedCompleted?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MarketingTrendRowData
     */
    purchaseCostQualityAvailable?: boolean;
    /**
     * Cost completeness for the completed plus received order-performance population.
     * @type {boolean}
     * @memberof MarketingTrendRowData
     */
    purchaseCostCompleteGross?: boolean;
    /**
     * Cost completeness for the canonical completed-order population.
     * @type {boolean}
     * @memberof MarketingTrendRowData
     */
    purchaseCostCompleteCompleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MarketingTrendRowData
     */
    orders?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketingTrendRowData
     */
    clicks?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketingTrendRowData
     */
    impressions?: number;
    /**
     * Compatibility PNO for completed plus received order-performance turnover; use pnoCompleted for the canonical completed-order basis.
     * @type {number}
     * @memberof MarketingTrendRowData
     */
    pno?: number | null;
    /**
     * Canonical PNO for completed orders; null when completed turnover is non-positive or marketing spend is negative.
     * @type {number}
     * @memberof MarketingTrendRowData
     */
    pnoCompleted?: number | null;
    /**
     * Compatibility POAS for completed plus received order-performance turnover; null for negative turnover or non-positive marketing spend. Use poasCompleted for the canonical completed-order basis.
     * @type {number}
     * @memberof MarketingTrendRowData
     */
    poas?: number | null;
    /**
     * Canonical POAS for completed orders; null when completed-order cost coverage is incomplete, turnover is negative, or marketing spend is non-positive.
     * @type {number}
     * @memberof MarketingTrendRowData
     */
    poasCompleted?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketingTrendRowData
     */
    ctr?: number | null;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof MarketingTrendRowData
     */
    cpc?: NullableMoneyOutput | null;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof MarketingTrendRowData
     */
    cpm?: NullableMoneyOutput | null;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof MarketingTrendRowData
     */
    costPerOrder?: NullableMoneyOutput | null;
    /**
     * 
     * @type {number}
     * @memberof MarketingTrendRowData
     */
    conversionRate?: number | null;
    /**
     * 
     * @type {PartialProfitabilityData}
     * @memberof MarketingTrendRowData
     */
    partialProfitability?: PartialProfitabilityData | null;
    /**
     * 
     * @type {PartialProfitabilityData}
     * @memberof MarketingTrendRowData
     */
    partialProfitabilityMarketing?: PartialProfitabilityData | null;
    /**
     * 
     * @type {MediaSourceQuality}
     * @memberof MarketingTrendRowData
     */
    mediaSourceQuality?: MediaSourceQuality;
    /**
     * 
     * @type {MarketingTrendRowDataFinanceScopeEnum}
     * @memberof MarketingTrendRowData
     */
    financeScope?: MarketingTrendRowDataFinanceScopeEnum;
}


/**
 * @export
 */
export const MarketingTrendRowDataFinanceScopeEnum = {
    CanonicalSelected: 'canonical_selected'
} as const;
export type MarketingTrendRowDataFinanceScopeEnum = typeof MarketingTrendRowDataFinanceScopeEnum[keyof typeof MarketingTrendRowDataFinanceScopeEnum];


/**
 * Check if a given object implements the MarketingTrendRowData interface.
 */
export function instanceOfMarketingTrendRowData(value: object): value is MarketingTrendRowData {
    return true;
}

export function MarketingTrendRowDataFromJSON(json: any): MarketingTrendRowData {
    return MarketingTrendRowDataFromJSONTyped(json, false);
}

export function MarketingTrendRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarketingTrendRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'] == null ? undefined : json['date'],
        'spend': json['spend'] == null ? undefined : MoneyOutputFromJSON(json['spend']),
        'turnover': json['turnover'] == null ? undefined : MoneyOutputFromJSON(json['turnover']),
        'turnoverCompleted': json['turnoverCompleted'] == null ? undefined : MoneyOutputFromJSON(json['turnoverCompleted']),
        'goodsMargin': json['goodsMargin'] === undefined ? undefined : json['goodsMargin'] === null ? null : NullableMoneyOutputFromJSON(json['goodsMargin']),
        'goodsMarginCompleted': json['goodsMarginCompleted'] === undefined ? undefined : json['goodsMarginCompleted'] === null ? null : NullableMoneyOutputFromJSON(json['goodsMarginCompleted']),
        'purchaseCostUnknownGross': json['purchaseCostUnknownGross'] == null ? undefined : json['purchaseCostUnknownGross'],
        'purchaseCostUnknownCompleted': json['purchaseCostUnknownCompleted'] == null ? undefined : json['purchaseCostUnknownCompleted'],
        'purchaseCostEstimatedGross': json['purchaseCostEstimatedGross'] == null ? undefined : json['purchaseCostEstimatedGross'],
        'purchaseCostEstimatedCompleted': json['purchaseCostEstimatedCompleted'] == null ? undefined : json['purchaseCostEstimatedCompleted'],
        'purchaseCostQualityAvailable': json['purchaseCostQualityAvailable'] == null ? undefined : json['purchaseCostQualityAvailable'],
        'purchaseCostCompleteGross': json['purchaseCostCompleteGross'] == null ? undefined : json['purchaseCostCompleteGross'],
        'purchaseCostCompleteCompleted': json['purchaseCostCompleteCompleted'] == null ? undefined : json['purchaseCostCompleteCompleted'],
        'orders': json['orders'] == null ? undefined : json['orders'],
        'clicks': json['clicks'] == null ? undefined : json['clicks'],
        'impressions': json['impressions'] == null ? undefined : json['impressions'],
        'pno': json['pno'] === undefined ? undefined : json['pno'] === null ? null : json['pno'],
        'pnoCompleted': json['pnoCompleted'] === undefined ? undefined : json['pnoCompleted'] === null ? null : json['pnoCompleted'],
        'poas': json['poas'] === undefined ? undefined : json['poas'] === null ? null : json['poas'],
        'poasCompleted': json['poasCompleted'] === undefined ? undefined : json['poasCompleted'] === null ? null : json['poasCompleted'],
        'ctr': json['ctr'] === undefined ? undefined : json['ctr'] === null ? null : json['ctr'],
        'cpc': json['cpc'] === undefined ? undefined : json['cpc'] === null ? null : NullableMoneyOutputFromJSON(json['cpc']),
        'cpm': json['cpm'] === undefined ? undefined : json['cpm'] === null ? null : NullableMoneyOutputFromJSON(json['cpm']),
        'costPerOrder': json['costPerOrder'] === undefined ? undefined : json['costPerOrder'] === null ? null : NullableMoneyOutputFromJSON(json['costPerOrder']),
        'conversionRate': json['conversionRate'] === undefined ? undefined : json['conversionRate'] === null ? null : json['conversionRate'],
        'partialProfitability': json['partialProfitability'] === undefined ? undefined : json['partialProfitability'] === null ? null : PartialProfitabilityDataFromJSON(json['partialProfitability']),
        'partialProfitabilityMarketing': json['partialProfitabilityMarketing'] === undefined ? undefined : json['partialProfitabilityMarketing'] === null ? null : PartialProfitabilityDataFromJSON(json['partialProfitabilityMarketing']),
        'mediaSourceQuality': json['mediaSourceQuality'] == null ? undefined : MediaSourceQualityFromJSON(json['mediaSourceQuality']),
        'financeScope': json['financeScope'] == null ? undefined : json['financeScope'],
    };
}

export function MarketingTrendRowDataToJSON(json: any): MarketingTrendRowData {
    return MarketingTrendRowDataToJSONTyped(json, false);
}

export function MarketingTrendRowDataToJSONTyped(value?: MarketingTrendRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'],
        'spend': MoneyOutputToJSON(value['spend']),
        'turnover': MoneyOutputToJSON(value['turnover']),
        'turnoverCompleted': MoneyOutputToJSON(value['turnoverCompleted']),
        'goodsMargin': NullableMoneyOutputToJSON(value['goodsMargin']),
        'goodsMarginCompleted': NullableMoneyOutputToJSON(value['goodsMarginCompleted']),
        'purchaseCostUnknownGross': value['purchaseCostUnknownGross'],
        'purchaseCostUnknownCompleted': value['purchaseCostUnknownCompleted'],
        'purchaseCostEstimatedGross': value['purchaseCostEstimatedGross'],
        'purchaseCostEstimatedCompleted': value['purchaseCostEstimatedCompleted'],
        'purchaseCostQualityAvailable': value['purchaseCostQualityAvailable'],
        'purchaseCostCompleteGross': value['purchaseCostCompleteGross'],
        'purchaseCostCompleteCompleted': value['purchaseCostCompleteCompleted'],
        'orders': value['orders'],
        'clicks': value['clicks'],
        'impressions': value['impressions'],
        'pno': value['pno'],
        'pnoCompleted': value['pnoCompleted'],
        'poas': value['poas'],
        'poasCompleted': value['poasCompleted'],
        'ctr': value['ctr'],
        'cpc': NullableMoneyOutputToJSON(value['cpc']),
        'cpm': NullableMoneyOutputToJSON(value['cpm']),
        'costPerOrder': NullableMoneyOutputToJSON(value['costPerOrder']),
        'conversionRate': value['conversionRate'],
        'partialProfitability': PartialProfitabilityDataToJSON(value['partialProfitability']),
        'partialProfitabilityMarketing': PartialProfitabilityDataToJSON(value['partialProfitabilityMarketing']),
        'mediaSourceQuality': MediaSourceQualityToJSON(value['mediaSourceQuality']),
        'financeScope': value['financeScope'],
    };
}

